import { motion } from "framer-motion";
import { Star, Quote, ShieldCheck, MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const TESTIMONIALS = [
  {
    initials: "R.M.",
    role: "Empresário do agronegócio · Campo Grande/MS",
    text: "Eu achava que perder metade de tudo era inevitável. A TSS estruturou a partilha antes do acordo e a economia tributária pagou a operação inteira. Sigilo total do início ao fim.",
  },
  {
    initials: "C.A.",
    role: "Médica · São Paulo/SP",
    text: "Fui atendida 100% por videochamada, sem expor minha vida em fóruns e cartórios. Encontraram bens que nem constavam na partilha inicial. Profissionalismo raro.",
  },
  {
    initials: "J.T.",
    role: "Investidora · Naviraí/MS",
    text: "O que mais me impressionou foi a frieza estratégica. Enquanto eu estava emocionalmente esgotada, eles conduziam cada prazo e cada documento com precisão cirúrgica.",
  },
  {
    initials: "F.S.",
    role: "Sócio de holding familiar · Curitiba/PR",
    text: "Meu caso envolvia quotas de três empresas. A equipe integrou direito de família e tributário de um jeito que nenhum escritório anterior tinha conseguido explicar.",
  },
];

export const Testimonials = () => (
  <section id="depoimentos" data-testid="testimonials-section" className="relative py-24 sm:py-32 bg-[#0B1320]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Provas sociais"
        title="Quem protegeu o patrimônio com a TSS"
        description="Identidades preservadas por sigilo profissional. O mesmo compromisso que teremos com o seu caso."
        align="center"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-14 max-w-5xl mx-auto" data-testid="testimonials-grid">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.initials} delay={i * 0.08}>
            <motion.figure
              whileHover={{ y: -5 }}
              transition={{ duration: 0.3 }}
              data-testid={`testimonial-card-${i}`}
              className="h-full relative border border-amber-500/15 bg-gradient-to-b from-[#141F33] to-[#101A2C] rounded-2xl p-8 hover:border-amber-400/40 transition-colors duration-500"
            >
              <Quote className="absolute top-6 right-7 w-8 h-8 text-amber-500/15" />
              <div className="flex items-center gap-1" aria-label="5 de 5 estrelas">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-amber-400" fill="currentColor" />
                ))}
              </div>
              <blockquote className="text-sm sm:text-base text-slate-300 leading-relaxed mt-5">
                “{t.text}”
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-7 pt-6 border-t border-amber-500/10">
                <div className="w-11 h-11 rounded-full border border-amber-400/40 bg-[#0B1320] flex items-center justify-center">
                  <span className="font-display text-sm font-semibold gold-text">{t.initials}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-slate-100">{t.initials}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-10 flex flex-col items-center gap-6">
        <p className="flex items-center gap-2 text-[11px] text-slate-500 text-center max-w-md" data-testid="testimonials-disclaimer">
          <ShieldCheck className="w-3.5 h-3.5 text-amber-500/70 shrink-0" />
          Depoimentos ilustrativos com iniciais fictícias, respeitando o sigilo profissional advocatício.
        </p>
        <motion.a
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          href={waLink(WA_MESSAGES.final)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="testimonials-cta-whatsapp"
          className="inline-flex items-center gap-2.5 gold-surface text-[#0B1320] font-bold text-sm sm:text-base px-8 py-4 rounded-full shadow-[0_0_36px_rgba(212,175,55,0.3)] hover:shadow-[0_0_55px_rgba(212,175,55,0.5)] transition-shadow duration-300"
        >
          <MessageCircle className="w-5 h-5" />
          Quero o Mesmo Nível de Proteção
        </motion.a>
      </Reveal>
    </div>
  </section>
);
